import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { API_ROUTES } from "../../api/ApiRoutes";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import type {
  GetUserPokerStatsParams,
  UserPokerStats,
} from "../../types/poker";

type StoredToken = { AccessToken?: string };

const fetchUserPokerStats = async (
  params: GetUserPokerStatsParams,
): Promise<UserPokerStats> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const body: Record<string, unknown> = {
    user_id: params.user_id,
    start_date: params.start_date ?? null,
    end_date: params.end_date ?? null,
  };
  if (params.money_type) {
    body.money_type = params.money_type;
  }

  const url = API_ROUTES.GET_USER_POKER_STATS.replace(
    "{user_id}",
    params.user_id,
  );

  const response = await instance.post(url, body);
  const responseBody = response?.data?.data;
  if (!responseBody || typeof responseBody !== "object") {
    return {};
  }
  return responseBody as UserPokerStats;
};

export const useGetUserPokerStats = (
  params: GetUserPokerStatsParams | null,
): UseQueryResult<UserPokerStats, Error> => {
  return useQuery<UserPokerStats, Error>({
    queryKey: [
      "GET_USER_POKER_STATS",
      params?.user_id ?? "",
      params?.start_date ?? "",
      params?.end_date ?? "",
      params?.money_type ?? "",
    ],
    queryFn: () => fetchUserPokerStats(params as GetUserPokerStatsParams),
    enabled: Boolean(params?.user_id),
    placeholderData: (previousData) => previousData,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
